import { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import {
    useDataModel,
    QueryContext,
    params,
    arrayOf as arrayType,
    shape as shapeType,
    string as stringType,
    number as numberType,
    bool as boolType
} from '@thd-nucleus/data-sources';

const SERVER_SIDE_PRODUCT_POD_RENDER_COUNT = 12;

const limitProductsToDisplay = ({ products = [], setLimit = false, limitCount = 12 }) => {
    if (setLimit) { return products.slice(0, limitCount); }
    return products;
};

const hasInStoreFilter = (resultsData) => {
    const { searchModel } = resultsData || {};
    const { appliedDimensions } = searchModel || {};
    const getItFast = (appliedDimensions || [])
        .filter((dimension) => (dimension.label || '').toUpperCase() === 'GET IT FAST');
    if (!getItFast.length) {
        return false;
    }
    const storePickUp = getItFast
        .find((dimension) => dimension.refinements
            .find((refinement) => refinement.label === 'Pick Up Today'));
    return !!storePickUp;
};

export const useSearchContext = () => {
    const { customContext, isServer } = useContext(ExperienceContext);
    const { variables = {}, isSearch, isBrowse } = customContext || {};
    const { isClientResolved } = useContext(QueryContext);

    const keyword = variables?.keyword || '';
    const navParam = variables?.navParam || '';
    const storeId = variables?.storeId;
    const isServerStore = storeId === '121' || storeId === '8119';
    const isPLPSearchPage = (isSearch || isBrowse);

    const { data, loading, error } = useDataModel('searchModel', {
        variables,
        skip: (!keyword && !navParam) || (!isServer && isServerStore),
        ssr: false
    });

    const resolved = isClientResolved({ queryName: 'searchModel' });

    const allProducts = data?.searchModel?.products || [];

    const products = limitProductsToDisplay({
        products: allProducts,
        setLimit: isServer && isSearch,
        limitCount: SERVER_SIDE_PRODUCT_POD_RENDER_COUNT
    });

    const storeSkuIds = resolved
        ? products?.map((product) => product.identifiers?.storeSkuNumber).filter((sku) => !!sku)
        : [];


    return {
        isPLPSearchPage,
        keyword,
        isServer,
        variables,

        data,
        loading,
        error,
        resolved,

        products,
        allProducts,
        itemIds: allProducts.map((product) => product?.itemId).filter((id) => !!id),
        storeSkuIds,
        hasInStoreFilter,
    };
};

useSearchContext.dataModel = {
    searchModel: params({
        keyword: stringType(),
        navParam: stringType(),
        storeId: stringType(),
        isBrandPage: boolType(),
    }).shape({
        searchReport: shapeType({
            keyword: stringType(),
            totalProducts: numberType()
        }),
        products: arrayType(shapeType({
            identifiers: shapeType({
                storeSkuNumber: stringType(),
                productType: stringType()
            })
        })),
        appliedDimensions: arrayType(shapeType({
            label: stringType(),
            refinements: arrayType(shapeType({
                label: stringType()
            }))
        }))
    })
};